<template>
    <div class="d-flex align-center">
        <v-avatar v-if="taskAssignees.length > 3" color="neutral_n40" size="24" class="overlap-avatar">
            <span class="neutral_n300--text font-weight-medium" style="font-size: 10px;">
                +{{ taskAssignees.length - 3 }}
            </span>
        </v-avatar>
        <template v-for="(assignee, index) in taskAssignees">
            <v-avatar
                v-if="index < 3"
                :key="index"
                :color="assignee.assigned_avatar ? 'white' : assignee.assigned_type === 'group' ? 'n5' : 'neutral_n40'"
                size="24"
                style="margin-left: -5px;"
                :class="!assignee.assigned_avatar ? 'overlap-avatar' : ''"
            >
                <img
                    v-if="assignee.assigned_avatar"
                    :alt="assignee.assigned_initials"
                    :src="BASE_URL + assignee.assigned_avatar"
                />
                <span
                    v-else
                    :class="assignee.assigned_type === 'group' ? 'white--text' : 'neutral_n300--text'"
                    class="font-weight-medium"
                    style="font-size: 10px;"
                >
                    {{ assignee.assigned_initials }}
                </span>
            </v-avatar>
        </template>
    </div>
</template>

<script>
export default {
    name: "TaskAssigneeAvatars",
    props: {
        taskAssignees: {
            type: Array,
            required: true
        }
    },
    setup() {

        const PROTOCOL = process.env.VUE_APP_PROTOCOL
            ? process.env.VUE_APP_PROTOCOL
            : "";
        const HOST = process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : "";
        const BASE_URL = `${PROTOCOL}://${HOST}/`;

        return {
            BASE_URL
        }
    }
};
</script>
<style lang="scss" scoped>
.overlap-avatar {
    box-shadow: 0px 0px 0 1px var(--v-n1-base) !important;
}
</style>
